export default __webpack_public_path__ + "static/media/a038-4.74170b18.svg";